import CheckTable from "./components/CheckTable";
import React, { useState, useEffect } from 'react';
import axios from '../../../api/axios';
import {
  columnsDataCheck,
} from "./variables/columnsData";

const NewRepo = () => {
  const [data, setData] = useState([]);
 
  useEffect(() => {
    const fetchData = async () => {
      const storedToken = localStorage.getItem("token"); 
      
      let token = "Bearer " + storedToken.replace(/"/g, '');
      const headers = {
        Authorization: token,
        "Content-Type": "application/json",
      };
      try {
        const response = await axios.get(
          "/api/reports/getallreports",
          { headers }
        );
        setData(response.data);
      } catch (error) {
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <CheckTable columnsData={columnsDataCheck} tableData={data} />
      </div>
    </div>
  );
};

export default NewRepo;
